<template>
  <div>
    <div v-if="channel?.id" class="card card-custom gutter-b">
      <!--begin::Header-->
      <div class="card-header align-items-center px-4 py-3">
        <div class="card-title">
          <h3 class="card-label">
            {{ channel.title }}
          </h3>
        </div>
      </div>
      <!--end::Header-->
      <!--begin::Body-->
      <div class="card-body">
        <div class="alert alert-light mt-5 text-center" role="alert">
          <a
            :href="`https://media.mirol.ir/${channel.slug}`"
            dir="ltr"
            class="alert-link"
            target="_blank"
            v-text="`https://media.mirol.ir/${channel.slug}`"
          >
          </a>
          <button
            class="btn p-0 mx-1"
            @click="copyText(`https://media.mirol.ir/${channel.slug}`, $event)"
          >
            <i class="far fa-1x fa-copy"></i>
          </button>
        </div>
      </div>
      <!--end::Body-->
    </div>

    <div v-if="channel?.id" class="card card-custom">
      <!--begin::Header-->
      <div class="card-header align-items-center px-4 py-3">
        <div class="card-title">
          <h3 class="card-label">
            برنامه‌ها
          </h3>
        </div>
      </div>
      <!--end::Header-->
      <!--begin::Body-->
      <div class="card-body">
        <div
          class="mt-7"
          v-if="channel.programs && channel.programs.length === 0"
        >
          برنامه‌ای یافت نشد، یک یا چند برنامه اضافه کنید.
        </div>

        <div class="row">
          <div
            v-for="program in programsList"
            :key="program.id"
            class="col-md-3"
          >
            <router-link
              class="d-flex flex-wrap align-items-center mb-10"
              :to="{ name: 'programs-show', params: { id: program.id } }"
            >
              <!--begin::Symbol-->
              <div class="symbol symbol-60 symbol-2by3 flex-shrink-0">
                <div
                  class="symbol-label"
                  :style="`background-image: url('${program.poster}')`"
                ></div>
              </div>
              <!--end::Symbol-->
              <!--begin::Title-->
              <div class="d-flex flex-column ml-4 flex-grow-1 mr-2">
                <a
                  href="#"
                  class="text-dark-75 font-weight-bold text-hover-primary font-size-lg mb-1"
                >
                  {{ program.name }}
                </a>
              </div>
              <!--end::Title-->
            </router-link>
          </div>
        </div>
      </div>
      <!--end::Body-->
    </div>
  </div>
</template>

<script>
import { SET_BREADCRUMB } from "@/core/services/store/breadcrumbs.module";
import {
  DESTROY_CHANNEL,
  FETCH_CHANNEL
} from "@/core/services/store/channels.module";
import { mapGetters } from "vuex";
import Swal from "sweetalert2";
import { SET_ACTIONS } from "@/core/services/store/actions.module";

export default {
  name: "channels-show",
  data() {
    return {
      loaded: false,
      isAdmin: this.$route.name.startsWith("admin"),
      isCompany: this.$route.name.startsWith("company"),
      programsList: []
    };
  },
  components: {},
  computed: {
    ...mapGetters(["channel"])
  },
  mounted() {
    this.getChannel();

    if (this.isAdmin) {
      this.userShowRoute = "admin-users-show";
    } else if (this.isCompany) {
      this.userShowRoute = "company-users-show";
    }

    this.eventHub.$on("delete-channel-event", this.destroy);
  },

  beforeDestroy() {
    this.eventHub.$off(["delete-channel-event"]);
  },

  methods: {
    getChannel() {
      let channelId = this.$route.params.id;
      this.loaded = false;

      this.$store
        .dispatch(FETCH_CHANNEL, channelId)
        .then(async () => {
          this.loaded = true;
          this.setBreadcrumbs();
          this.setActions();

          for (let i in this.channel.programs) {
            let program = this.channel.programs[i];
            let poster = "";
            if (program.information?.poster) {
              poster = await this.posterUrl(
                program.id,
                program.information.poster
              );
            }

            this.programsList.push({
              id: program.id,
              name: program.name,
              poster: poster
            });
          }
        })
        .catch(() => {
          this.loaded = true;
        });
    },
    setBreadcrumbs() {
      let channelsRouteName = "channels-index";
      let items = [];
      items.push({ title: "رسانه من", route: { name: channelsRouteName } });
      items.push({ title: this.channel.title });
      this.$store.dispatch(SET_BREADCRUMB, items);
    },
    setActions() {
      this.$store.dispatch(SET_ACTIONS, {
        buttons: [
          {
            name: '<i class="flaticon2-trash"></i>حذف',
            event: "delete-channel-event",
            class: "btn-danger"
          }
        ],
        links: [
          {
            name: '<i class="flaticon-edit"></i>ویرایش',
            to: {
              name: "channels-edit",
              params: { id: this.$route.params.id }
            },
            class: "btn-primary"
          }
        ]
      });
    },
    destroy() {
      Swal.fire({
        title: "",
        text: "آیا از حذف کانال اطمینان دارید؟",
        icon: "warning",
        showCancelButton: true,
        confirmButtonText: "بله",
        confirmButtonColor: "#4554a0",
        cancelButtonText: "خیر",
        cancelButtonColor: "#ed1c24",
        heightAuto: false
      }).then(result => {
        if (result.isConfirmed) {
          this.$store
            .dispatch(DESTROY_CHANNEL, this.$route.params.id)
            .then(() => {
              this.$router.push({
                name: "channels-index"
              });
            });
        }
      });
    }
  }
};
</script>
